import { breakpoints } from '../global/breakpoints';
import { palette } from '../global/palette';
import { shape } from '../global/shape';
import { typography } from '../global/typography';
export const MuiTooltip = {
    MuiTooltip: {
        styleOverrides: {
            tooltip: Object.assign(Object.assign({}, typography.caption), { backgroundColor: palette.grey[800], borderRadius: shape.borderRadius, padding: '6px 8px' }),
            tooltipPlacementBottom: {
                margin: 8,
                [breakpoints.up('sm')]: {
                    margin: 8,
                },
            },
            tooltipPlacementTop: {
                margin: 8,
                [breakpoints.up('sm')]: {
                    margin: 8,
                },
            },
            tooltipPlacementLeft: {
                margin: 8,
                [breakpoints.up('sm')]: {
                    margin: 8,
                },
            },
            tooltipPlacementRight: {
                margin: 8,
                [breakpoints.up('sm')]: {
                    margin: 8,
                },
            },
            arrow: { color: palette.grey[800] },
        },
    },
};
